import { Coordinate, GeoJsonPolygons } from '../../../models/mapViewModel';
import {
  ContainedPolygons,
  PolygonsApi,
  PolygonsForAddressMapBuilding,
  PolygonsForMapBuilding,
} from '../models/polygonsModel';

export const buildMapPolygonsFromGeoJsonAdapter = (
  polygonsApi: PolygonsApi[], //GeoJsonPolygons[]
): PolygonsForMapBuilding[] => {
  //Coordinate[][]
  // let response: Coordinate[][] = [];
  const polygonsAdapted: PolygonsForMapBuilding[] = polygonsApi
    .filter(
      (polygon) => polygon.display_info !== null && polygon.geo_points !== null,
    )
    .map((polygon) => {
      //Coordinate[][]

      const geoJsonPolygon = polygon.geo_points;
      const geometryType = geoJsonPolygon.type;

      if (geometryType === 'MultiPolygon') {
        // For MultiPolygon: coordinates is [[[[lng,lat], [lng,lat]]]]
        const multiPolygonCoords = geoJsonPolygon.coordinates as [
          [[[number, number]]],
        ];
        const allPolygons: Coordinate[][] = multiPolygonCoords.map(
          (polygonRing) => {
            const coordinates = polygonRing[0]; // Get the outer ring
            return coordinates.map((innerCoordinate) => {
              const [lng, lat] = innerCoordinate;
              return { lat, lng };
            });
          },
        );

        // Use the first polygon for display compatibility
        return {
          id: polygon.id,
          name: polygon.name,
          polygon: allPolygons[0] || [],
          geometry_type: 'MultiPolygon',
          multipolygon: allPolygons,
        };
      }

      // For Polygon: coordinates is [[[lng,lat], [lng,lat]]]
      const coordinates = (
        geoJsonPolygon.coordinates as [[[number, number]]]
      )[0]; // 0 => [[lng,lat], [lng,lat]]

      const innerCoordinates: Coordinate[] = coordinates.map(
        (innerCoordinate) => {
          const [lng, lat] = innerCoordinate; // => [lng,lat]
          const cr: Coordinate = { lat, lng };
          return cr;
        },
      );
      return {
        id: polygon.id,
        name: polygon.name,
        polygon: innerCoordinates,
        geometry_type: 'Polygon',
      };
    });
  return polygonsAdapted;
};

export const buildMapAddressPolygonAdapter = (
  polygon: PolygonsApi, //GeoJsonPolygons[]
  force_center?: Coordinate,
): PolygonsForAddressMapBuilding => {
  //Coordinate[][]
  // let response: Coordinate[][] = [];
  //Coordinate[][]
  const geoJsonPolygon = polygon.geo_points;
  const geometryType = geoJsonPolygon.type;

  let innerCoordinates: Coordinate[] = [];
  let multipolygonCoords: Coordinate[][] | undefined;

  if (geometryType === 'MultiPolygon') {
    // For MultiPolygon: coordinates is [[[[lng,lat], [lng,lat]]]]
    const multiPolygonCoords = geoJsonPolygon.coordinates as [
      [[[number, number]]],
    ];
    const allPolygons: Coordinate[][] = multiPolygonCoords.map(
      (polygonRing) => {
        const coordinates = polygonRing[0]; // Get the outer ring
        return coordinates.map((innerCoordinate) => {
          const [lng, lat] = innerCoordinate;
          return { lat, lng };
        });
      },
    );
    innerCoordinates = allPolygons[0] || [];
    multipolygonCoords = allPolygons;
  } else {
    // For Polygon: coordinates is [[[lng,lat], [lng,lat]]]
    const coordinates = (geoJsonPolygon.coordinates as [[[number, number]]])[0]; // 0 => [[lng,lat], [lng,lat]]
    innerCoordinates = coordinates.map((innerCoordinate) => {
      const [lng, lat] = innerCoordinate; // => [lng,lat]
      const cr: Coordinate = { lat, lng };
      return cr;
    });
  }

  return {
    id: polygon.id,
    name: polygon.name,
    polygon: innerCoordinates,
    polygon_type: polygon.display_info.polygon_type,
    geometry_type: geometryType,
    multipolygon: multipolygonCoords,
    center: force_center
      ? force_center
      : {
          lat: polygon.display_info.center.lat ?? 0,
          lng: polygon.display_info.center.lng ?? 0,
        },
    zoom: polygon.display_info.zoom,
  };
};
